import { wgs84CoordsToDisplay } from './coords';
import { openRingCoords } from './geometry';
import { isAreaFeatureType } from './featureMeta';

/** 屏幕框：归一化 min/max */
export function normalizeScreenBox(a, b) {
  return {
    minX: Math.min(a.x, b.x),
    minY: Math.min(a.y, b.y),
    maxX: Math.max(a.x, b.x),
    maxY: Math.max(a.y, b.y)
  };
}

export function pointInScreenBox(p, box) {
  return p.x >= box.minX && p.x <= box.maxX && p.y >= box.minY && p.y <= box.maxY;
}

export function segmentsIntersect(a, b, c, d) {
  const cross = (p, q, r) => (q.x - p.x) * (r.y - p.y) - (q.y - p.y) * (r.x - p.x);
  const d1 = cross(a, b, c);
  const d2 = cross(a, b, d);
  const d3 = cross(c, d, a);
  const d4 = cross(c, d, b);
  if (((d1 > 0 && d2 < 0) || (d1 < 0 && d2 > 0)) && ((d3 > 0 && d4 < 0) || (d3 < 0 && d4 > 0))) {
    return true;
  }
  return false;
}

export function segmentHitsScreenBox(a, b, box) {
  if (pointInScreenBox(a, box) || pointInScreenBox(b, box)) return true;
  const corners = [
    [{ x: box.minX, y: box.minY }, { x: box.maxX, y: box.minY }],
    [{ x: box.maxX, y: box.minY }, { x: box.maxX, y: box.maxY }],
    [{ x: box.maxX, y: box.maxY }, { x: box.minX, y: box.maxY }],
    [{ x: box.minX, y: box.maxY }, { x: box.minX, y: box.minY }]
  ];
  return corners.some(([c1, c2]) => segmentsIntersect(a, b, c1, c2));
}

/** 图形是否与屏幕选择框相交（点/线/面/文字/手绘） */
export function featureIntersectsScreenBox(map, feature, box) {
  if (!map || !feature || !box) return false;
  let coords = feature.coordinates || [];
  if (isAreaFeatureType(feature.type)) coords = openRingCoords(coords);
  if (feature.type === 'text') coords = coords.slice(0, 1);
  if (!coords.length) return false;
  const display = wgs84CoordsToDisplay(coords, map);
  const pts = display.map((c) => map.project(c));
  if (pts.some((p) => pointInScreenBox(p, box))) return true;
  const closed = isAreaFeatureType(feature.type) && pts.length >= 3;
  const n = closed ? pts.length : pts.length - 1;
  for (let i = 0; i < n; i += 1) {
    const a = pts[i];
    const b = pts[(i + 1) % pts.length];
    if (segmentHitsScreenBox(a, b, box)) return true;
  }
  return false;
}

export function collectFeaturesInScreenBox(map, features, box) {
  return (features || []).filter((f) => featureIntersectsScreenBox(map, f, box));
}

/** 更新/隐藏框选矩形 DOM */
export function updateBoxSelectOverlay(map, box) {
  if (!map?.getContainer) return;
  const container = map.getContainer();
  let el = container.querySelector('.zhxt-draw-box-select');
  if (!box) {
    if (el) el.style.display = 'none';
    return;
  }
  if (!el) {
    el = document.createElement('div');
    el.className = 'zhxt-draw-box-select';
    container.appendChild(el);
  }
  el.style.display = 'block';
  el.style.left = `${box.minX}px`;
  el.style.top = `${box.minY}px`;
  el.style.width = `${Math.max(0, box.maxX - box.minX)}px`;
  el.style.height = `${Math.max(0, box.maxY - box.minY)}px`;
}
